<ng-template [ngIf]="!isLoading">
  <button class="btn back-btn" (click)="goBack()">
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="white" fill-opacity="0.4" />
      <rect width="40" height="40" rx="20" fill="black" fill-opacity="0.3" />
      <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="white" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </button>
  <div #scrollContainerView *ngIf="!searchTerm" class="container-fluid ps-4 pe-4" style="overscroll-behavior: contain;">
    <div class="row align-items-center">
      <div style="font-family: 'Manrope'; font-size: 15px;  margin: 15px auto; font-weight: 700;">{{ categoryName }}</div>
      <div class="row" style="padding: 0px 0px 0px 0px !important; margin-left: 0px">
        <div class="scroll" style="padding: 4px !important">
          <div class="col-6 col-sm-6 col-md-3 col-lg-2" style="margin: 10px 20px 10px 0px; padding: 0px"
            *ngFor="let event of eventList">
            <mat-card
              (click)="cardDetail(event.viewer_hash, true, event.restricted == true ? true : false, event.start_time, event.categoryName, event?.default_upload, event?.isHost, event)"
              style="border-radius: 15px;">
              <img class="image-f" mat-card-image
                [src]="event?.imageUrl? event.imageUrl : 'assets/images/default_cover.png'" />
              <div class="event-lock-overlay" *ngIf="(event.locked == 1 || event.locked == true) && event.isHost">
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="white">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
                </svg>
              </div>
              <div class="event-lock-badge" *ngIf="(event.locked == 1 || event.locked == true) && !event.isHost">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="white">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
                </svg>
              </div>
              <div mat-card-avatar style="margin-bottom: 20px !important; position: absolute;
                bottom: -16px;border: 1px solid whitesmoke;margin-left: 5px;height: 37px;width: 37px;">
                <button *ngIf="!event.collaborators[0]?.imageUrl" class="profile-image">
                  {{ event.collaborators[0]?.name?.charAt(0)?.trim() }}
                </button>
                <img *ngIf="event.collaborators[0]?.imageUrl" mat-card-sm-image class="avatar"
                  [src]="event.collaborators[0]?.imageUrl" />
              </div>
              <div class="upcoming-div">
                <svg *ngIf="event.categoryName == 'upcoming events'" width="16" height="16" viewBox="0 0 16 16"
                  fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.33301 7.99935C1.33301 5.48519 1.33301 4.22811 2.11406 3.44706C2.89511 2.66602 4.15218 2.66602 6.66634 2.66602H9.33301C11.8472 2.66602 13.1042 2.66602 13.8853 3.44706C14.6663 4.22811 14.6663 5.48519 14.6663 7.99935V9.33268C14.6663 11.8468 14.6663 13.1039 13.8853 13.885C13.1042 14.666 11.8472 14.666 9.33301 14.666H6.66634C4.15218 14.666 2.89511 14.666 2.11406 13.885C1.33301 13.1039 1.33301 11.8468 1.33301 9.33268V7.99935Z"
                    stroke="currentColor" />
                  <path d="M4.66699 2.66602V1.66602" stroke="currentColor" stroke-linecap="round" />
                  <path d="M11.333 2.66602V1.66602" stroke="currentColor" stroke-linecap="round" />
                  <circle cx="11" cy="11" r="1" stroke="currentColor" />
                  <path d="M1.66699 6H14.3337" stroke="currentColor" stroke-linecap="round" />
                </svg>

                <span style="padding: 5px;">  {{ event?.start_time * 1000 | date : "EEEE, d MMM yy" }} </span>
              </div>
            </mat-card>
            <p class="card-text card-event-name RM14">
              {{ event?.name | titlecase }}
            </p>
            <p>
              <i *ngIf="event.collaborators.length> 1" class="card-subtext">
                <svg width="16" height="16"
                  viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="8.00065" cy="3.9987" r="2.66667" stroke="#808080" stroke-width="1.25" />
                  <path d="M12 5.99935C13.1046 5.99935 14 5.25316 14 4.33268C14 3.41221 13.1046 2.66602 12 2.66602"
                    stroke="#808080" stroke-width="1.25" stroke-linecap="round" />
                  <path d="M4 5.99935C2.89543 5.99935 2 5.25316 2 4.33268C2 3.41221 2.89543 2.66602 4 2.66602"
                    stroke="#808080" stroke-width="1.25" stroke-linecap="round" />
                  <ellipse cx="8" cy="11.3346" rx="4" ry="2.66667" stroke="#808080" stroke-width="1.25" />
                  <path
                    d="M13.333 12.6654C14.5025 12.4089 15.333 11.7594 15.333 10.9987C15.333 10.238 14.5025 9.5885 13.333 9.33203"
                    stroke="#808080" stroke-width="1.25" stroke-linecap="round" />
                  <path
                    d="M2.66699 12.6654C1.49749 12.4089 0.666992 11.7594 0.666992 10.9987C0.666992 10.238 1.49749 9.5885 2.66699 9.33203"
                    stroke="#808080" stroke-width="1.25" stroke-linecap="round" />
                </svg>
              </i>
              <span *ngIf="event.collaborators.length > 1" class="card-subtext"
                style="font-size: 12px !important;padding-left: 5px;padding-right: 8px;">{{
                event.collaborators.length }}</span>

              <i class="card-subtext">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1088_235)">
                    <path
                      d="M1.33301 7.9987C1.33301 4.856 1.33301 3.28465 2.30932 2.30834C3.28563 1.33203 4.85698 1.33203 7.99967 1.33203C11.1424 1.33203 12.7137 1.33203 13.69 2.30834C14.6663 3.28465 14.6663 4.856 14.6663 7.9987C14.6663 11.1414 14.6663 12.7127 13.69 13.6891C12.7137 14.6654 11.1424 14.6654 7.99967 14.6654C4.85698 14.6654 3.28563 14.6654 2.30932 13.6891C1.33301 12.7127 1.33301 11.1414 1.33301 7.9987Z"
                      stroke="#808080" stroke-width="1.25" />
                    <circle cx="10.6673" cy="5.33333" r="1.33333" stroke="#808080" stroke-width="1.25" />
                    <path
                      d="M1.33301 8.33277L2.50073 7.31102C3.10825 6.77945 4.02386 6.80994 4.59466 7.38075L7.45448 10.2406C7.91264 10.6987 8.63384 10.7612 9.16394 10.3886L9.36274 10.2489C10.1256 9.71282 11.1576 9.77493 11.8507 10.3987L13.9997 12.3328"
                      stroke="#808080" stroke-width="1.25" stroke-linecap="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1088_235">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </i><span style="font-size: 12px !important;padding-left: 5px;padding-right: 15px;">{{
                event.filesCount
                }}</span>
            </p>
          </div>
        </div>
      </div>
      <!-- <div
        class="col-12 col-sm-12 col-md-2 col-lg-3"
        style="margin: 20px 0px 0px 0px"
        *ngFor="let event of eventList"
      >
      
        <mat-card
          class="example-card"
          (click)="cardDetail(event.viewer_hash, true)"
        >
          <mat-card-title-group>
            <div class="col-4">
              <div style="border-radius: 3px 0px 0px 3px">
                <img *ngIf="event?.imageUrl"
                  style="height: 100px; width: 100px; object-fit: cover"
                  class="float-left"
                  mat-card-sm-image
                  [src]="event.imageUrl"
                />
                <img *ngIf="!event?.imageUrl"
                style="height: 100px; width: 100px; object-fit: cover"
                class="float-left"
                mat-card-sm-image
                src="/assets/images/blankImage.jpg"
              />
              </div>
            </div>
            <div class="col-8">
              <p class="card-text card-event-name RM14" style="margin: 6px 0px 2px">
                {{ event?.name | titlecase }}
              </p>
              <p class="card-text Grey2-color RR14">
                {{ event?.start_time * 1000 | date : "EEEE,  d MMM YY" }}
              </p>
              <div class="row">
                <div class="scroll">
                  <div
                    mat-card-avatar
                    style="margin-bottom: 0px !important"
                    *ngFor="let collaborator of event.collaborators"
                  >
                    <button
                      *ngIf="!collaborator?.imageUrl"
                      class="profile-image"
                    >
                      {{ collaborator.name?.charAt(0) }}
                    </button>
                    <img
                      *ngIf="collaborator.imageUrl"
                      mat-card-sm-image
                      class="avatar"
                      [src]="collaborator?.imageUrl"
                    />
                  </div>
                </div>
              </div>
            </div>
          </mat-card-title-group>
        </mat-card>
      </div> -->
    </div>
  </div>
  <button *ngIf="showScrollButton" class="scroll-top-button" style="position: fixed;
  bottom: 1rem;
  background-color: #f25344;
  right: 1rem;" mat-mini-fab color="accent" (click)="scrollToTop()">
    <mat-icon>arrow_upward</mat-icon>
  </button>
</ng-template>
<ng-template [ngIf]="moreEvents">
  <div class="stage" style="margin-left: 50%;padding-top: 30px;padding-bottom:30px;">
    <div class="dot-flashing"></div>
  </div>
</ng-template>
<ng-template [ngIf]="isLoading">
  <div class="overlay1">
    <span class="loader"></span>
  </div>
</ng-template>

<!-- Locked Event Popup -->
<div class="locked-popup-backdrop" *ngIf="showLockedPopup" (click)="showLockedPopup = false">
  <div class="locked-popup-card" (click)="$event.stopPropagation()">
    <div class="locked-popup-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="#EE4147">
        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
      </svg>
    </div>
    <h3 class="locked-popup-title">{{ lockedPopupIsHost ? 'Album' : 'Event Gallery' }} Temporarily Paused</h3>

    <ng-container *ngIf="lockedPopupIsHost">
      <p class="locked-popup-message">Your plan has expired and this album is currently locked. Renew your plan to restore access.</p>
      <div class="locked-popup-actions">
        <button class="locked-popup-btn locked-popup-btn--primary" (click)="navigateToRenew()">Renew Plan</button>
        <button class="locked-popup-btn locked-popup-btn--outline" (click)="showLockedPopup = false">Cancel</button>
      </div>
    </ng-container>

    <ng-container *ngIf="!lockedPopupIsHost">
      <p class="locked-popup-message">This Event Gallery is temporarily paused by the host. Please check back later.</p>
      <div class="locked-popup-actions">
        <button class="locked-popup-btn locked-popup-btn--primary" (click)="showLockedPopup = false">Go to Home</button>
      </div>
    </ng-container>
  </div>
</div>